// This is the value set to other in select fields
const OTHER = "other";
export default OTHER;
